import type { MobxDocument } from '../firestore-mobx'
import {
  ObservableModelWithDecorators,
  emptyCollection,
  emptyModel,
} from '../firestore-mobx/model'
import type { FirebaseRepository } from './FirebaseRepository'
import { type FirestoreCurrentPromptVersion } from '../firestore/CurrentPromptVersion/schema'
import { empty } from '../firestore/CurrentPromptVersion/schema'

export class CurrentPromptVersion extends ObservableModelWithDecorators<FirestoreCurrentPromptVersion> {
  static empty(repository: FirebaseRepository) {
    return emptyModel(repository, this, empty)
  }

  static emptyCollection(repository: FirebaseRepository) {
    return emptyCollection(repository, this, empty)
  }

  constructor(
    repository: FirebaseRepository,
    doc: MobxDocument<FirestoreCurrentPromptVersion>
  ) {
    super(repository, doc)
  }
}
